export default (editor) => {
  editor.wrapBlock('list_item');
  const {
    value: { focusBlock, document },
  } = editor;
  const parent = document.getParent(focusBlock.key);
  editor.wrapBlockByKey(parent.key, 'unordered_list');
  const newParent = editor.value.document.getParent(focusBlock.key);
  const grandParent = editor.value.document.getParent(newParent.key);
  const greatGrandParent = editor.value.document.getParent(grandParent.key);
  const indexOfParentListItem = greatGrandParent.nodes
    .toArray()
    .indexOf(grandParent);
  const previousItem =
    greatGrandParent.nodes.toArray()[indexOfParentListItem - 1];
  let index = 0;
  if (previousItem !== undefined && previousItem.type === 'unordered_list') {
    previousItem.nodes.toArray().forEach((item) => {
      editor.moveNodeByKey(item.key, grandParent.key, index);
      index += 1;
    });
  }

  const nextItem = greatGrandParent.nodes.toArray()[indexOfParentListItem + 1];
  index += 1;
  if (nextItem !== undefined && nextItem.type === 'unordered_list') {
    nextItem.nodes.toArray().forEach((item) => {
      editor.moveNodeByKey(item.key, grandParent.key, index);
      index += 1;
    });
  }
};
